<template>
  <div class='selectCustomer'>
    <div class='left_body'>
      <customer-search class="customer-search"
                       v-model="selectVal"
                       :controlButton="false"
                       @change="change"
                       placeholder="搜索客户"></customer-search>

      <data-list :table-style="{ name: 'webclient' }"
                 ref="list"
                 :selection="true"
                 height="294px"
                 :data="data"
                 :columns="columns"
                 :reserveSelection="true"
                 :rowKey="row => row.serviceId"
                 @selection-change="selectionChange"></data-list>
    </div>
    <div class='right_body'>
      <div>
        已选择（{{selectList.length}}）
      </div>
      <div v-for="item in selectList"
           :key="item.id"
           class="right_body_item">
        <div class="name_domain">
          <div>{{item.customerName}}</div>
          <div>{{item.domain}}</div>
        </div>
        <div class="cid">
          {{item.cid}}
          <el-button icon="el-icon-close"
                     circle
                     @click="remove(item)"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerSearch from '@/components/iglobalwin/formComponents/account/customerSearch.vue';
import { Post } from '@/backend/services/base/baseAjax.js';
import api from '@/backend/apiConfig/apiConfig'

let getServiceList = param => {
  return Post({
    url: api.service.effectServiceList,
    UrlParam: param,
  });
};

export default {
  name: 'selectCustomer',
  props: {
    value: {
      default: () => {
        return []
      },
    },
  },
  components: {
    customerSearch
  },
  data () {
    return {
      selectVal: '',
      columns: [
        {
          type: 'custInfo',
          label: '客户名称',
          width: 180,
          disabled: true,
          align: 'left',
          text: [
            {
              label: '',
              bind: 'customerName',
              style: {
                'text-align': 'center',
              },
            },
            {
              label: '',
              bind: 'domain',
              style: {
                'text-align': 'center',
              },
            },
          ],
        },
        {
          label: 'CID',
          bind: 'cid'
        },
      ],
      data: [],
      selectList: [],
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.selectList = val

        this.$nextTick(() => {
          val.forEach(item => {
            this.$refs.list.toggleRowSelection([item], true)
          });
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async change () {
      let { selectVal: customerId } = this
      let { data } = await getServiceList({
        customerId,
      })
      this.data = data
    },
    selectionChange (column) {
      this.selectList = column
      this.$emit('input', this.selectList)
    },
    remove (item) {
      this.$nextTick(() => {
        this.$refs.list.toggleRowSelection([item], false)
        this.$emit('input', this.selectList)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.selectCustomer {
	display: flex;
	flex-direction: row;

	.left_body,
	.right_body {
		width: 0;
		flex: 1;
		padding: 15px;
		height: 350px;
		border: 1px solid #d9d9d9;
	}

	.left_body {
		border-right: none;
	}

	.right_body {
		overflow-y: auto;
		overflow-x: hidden;
		// 改变滚动条样式
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #d8d8d8;
			border-radius: 6px;
		}

		&::-webkit-scrollbar-track {
			background-color: #fff;
			border-radius: 2px;
		}

		.right_body_item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 5px 15px;
			margin-bottom: 10px;
			background: #e6f8ff;
			border-radius: 5px;

			.name_domain {
				display: flex;
				flex-direction: column;

				div {
					line-height: 23px;
				}
			}

			.cid {
				.el-button {
					margin-left: 10px;
					padding: 4px;
				}
			}
		}
	}
}
</style>
